import TeamMembersTable from '../components/teamMembers/TeamMembersTable';
import { useTeamMembersTableStore } from '../store/myTeamTableStateStore';
import UsageTracker from '../../../utils/UsageTracker';
import { PAGE_NAMES } from '../../../constants/Navigation';
import { useEffect } from 'react';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PageHeader } from '../../header/components/PageHeader';
import Card from '../components/common/Card';
import TeamMembersTableFilters from '../components/filters/TeamMembersTableFilters';
import { getBreadcrumbItem } from '../constants/breadcrumbs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MyTeamMembers = () => {
  const store = useTeamMembersTableStore();
  const breadcrumbs = [getBreadcrumbItem({
    pageKey: 'MY_TEAM'
  }), getBreadcrumbItem({
    pageKey: 'MY_TEAM_MEMBERS',
    isCurrent: true
  })];
  useEffect(() => {
    UsageTracker.track('pageView', {
      screen: PAGE_NAMES.MY_TEAM_MEMBERS
    });
  }, []);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(PageHeader, {
      breadcrumbs: breadcrumbs,
      subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingSubTitles.MY_TEAM_MEMBERS"
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.heading.headingTitles.MY_TEAM_MEMBERS"
      })
    }), /*#__PURE__*/_jsxs(Card, {
      children: [/*#__PURE__*/_jsx(TeamMembersTableFilters, {
        store: store
      }), /*#__PURE__*/_jsx(TeamMembersTable, {})]
    })]
  });
};
export default MyTeamMembers;